import React, { useState } from "react";
import LinkAja from "../../assets/logo/link-aja.svg";
import BCA from "../../assets/logo/bca.png";
import OVO from "../../assets/logo/ovo.svg";
import Dana from "../../assets/logo/dana.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
const ListAccount = () => {
  const [toggleDeleteBtnIndex, setToggleDeleteBtnIndex] = useState(null);
  const toggleDelete = (deleteIndex) => {
    if (toggleDeleteBtnIndex === deleteIndex) setToggleDeleteBtnIndex(null);
    else setToggleDeleteBtnIndex(deleteIndex);
  };
  return (
    <div className="bg-white">
      <div className="py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 pr-10 lg:px-8">
        <div className="align-middle rounded-tl-lg rounded-tr-lg inline-block w-full py-4 overflow-hidden bg-white shadow-lg px-12"></div>
        <div className="align-middle inline-block w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pt-3 rounded-bl-lg rounded-br-lg">
          <table className="w-full ">
            <thead>
              <tr className="w-full">
                <th className="w-2/12 bg-seashell-500 px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Gambar
                </th>
                <th className=" bg-seashell-500 px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Nama Bank
                </th>
                <th className="w-2/12 bg-seashell-500 px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Nomor Rekening
                </th>
                <th className="w-4/12 flex-grow bg-seashell-500 px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Alamat
                </th>
                <th className=" bg-seashell-500 px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Status
                </th>

                <th className=" bg-seashell-500 px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Tindakan
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              <tr className="w-full">
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <div className="flex shadow-sm px-3 py-2 rounded-md">
                    <img
                      src={LinkAja}
                      className="h-12 ml-auto mr-auto"
                      alt=""
                    />
                  </div>
                </th>
                <th className=" px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Linkaja
                </th>
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  9213103813018
                </th>
                <th className="w-4/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Jln. Soekarno Hatta No.6, Malang, Jawa Timur
                </th>
                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <button className="bg-green-100 px-4 py-2 text-sm text-white rounded-md">
                    Aktif
                  </button>
                </th>

                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider ">
                  <div className="flex w-full items-center justify-center">
                    <button
                      className="mx-1"
                      onClick={() => {
                        toggleDelete(1);
                      }}
                    >
                      <img
                        src="/assets/icon/trash-can.svg"
                        className="h-5"
                        alt=""
                      />
                    </button>
                    <hr className="mx-1 border-r border-gray-300 h-5" />
                    <button className="mx-1">
                      <Link to="/account/edit-account">
                        <img
                          src="/assets/icon/bxs-pencil.svg"
                          className="h-5"
                          alt=""
                        />
                      </Link>
                    </button>
                    {toggleDeleteBtnIndex === 1 && (
                      <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                        <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                          <div
                            className="py-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="options-menu"
                          >
                            <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                              <p className="text-sm font-semibold">
                                Yakin Ingin menghapus item ini ?
                              </p>
                              <div className="flex ml-auto mt-6">
                                <button
                                  className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(1);
                                  }}
                                >
                                  Tidak
                                </button>
                                <button
                                  className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(1);
                                  }}
                                >
                                  Ya
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </th>
              </tr>
              <tr className="w-full">
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <div className="flex shadow-sm px-3 py-2 rounded-md">
                    <img src={BCA} className="h-8" alt="" />
                  </div>
                </th>
                <th className=" px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  BCA
                </th>
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  9213103813018
                </th>
                <th className="w-4/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Jln. Soekarno Hatta No.6, Malang, Jawa Timur
                </th>
                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <button className="bg-green-100 px-4 py-2 text-sm text-white rounded-md">
                    Aktif
                  </button>
                </th>

                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider ">
                  <div className="flex w-full items-center justify-center">
                    <button
                      className="mx-1"
                      onClick={() => {
                        toggleDelete(2);
                      }}
                    >
                      <img
                        src="/assets/icon/trash-can.svg"
                        className="h-5"
                        alt=""
                      />
                    </button>
                    <hr className="mx-1 border-r border-gray-300 h-5" />
                    <button className="mx-1">
                    <Link to="/account/edit-account">
                        <img
                          src="/assets/icon/bxs-pencil.svg"
                          className="h-5"
                          alt=""
                        />
                      </Link>
                    </button>
                    {toggleDeleteBtnIndex === 2 && (
                      <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                        <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                          <div
                            className="py-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="options-menu"
                          >
                            <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                              <p className="text-sm font-semibold">
                                Yakin Ingin menghapus item ini ?
                              </p>
                              <div className="flex ml-auto mt-6">
                                <button
                                  className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(2);
                                  }}
                                >
                                  Tidak
                                </button>
                                <button
                                  className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(2);
                                  }}
                                >
                                  Ya
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </th>
              </tr>
              <tr className="w-full">
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <div className="flex shadow-sm px-3 py-2 rounded-md">
                    <img
                      src="/assets/logo/mandiri.svg"
                      className="h-12"
                      alt=""
                    />
                  </div>
                </th>
                <th className=" px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Mandiri
                </th>
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  9213103813018
                </th>

                <th className="w-4/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Jln. Soekarno Hatta No.6, Malang, Jawa Timur
                </th>
                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <button className="bg-green-100 px-4 py-2 text-sm text-white rounded-md">
                    Aktif
                  </button>
                </th>

                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider ">
                  <div className="flex w-full items-center justify-center">
                    <button
                      className="mx-1"
                      onClick={() => {
                        toggleDelete(3);
                      }}
                    >
                      <img
                        src="/assets/icon/trash-can.svg"
                        className="h-5"
                        alt=""
                      />
                    </button>
                    <hr className="mx-1 border-r border-gray-300 h-5" />
                    <button className="mx-1">
                    <Link to="/account/edit-account">
                        <img
                          src="/assets/icon/bxs-pencil.svg"
                          className="h-5"
                          alt=""
                        />
                      </Link>
                    </button>
                    {toggleDeleteBtnIndex === 3 && (
                      <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                        <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                          <div
                            className="py-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="options-menu"
                          >
                            <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                              <p className="text-sm font-semibold">
                                Yakin Ingin menghapus item ini ?
                              </p>
                              <div className="flex ml-auto mt-6">
                                <button
                                  className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(3);
                                  }}
                                >
                                  Tidak
                                </button>
                                <button
                                  className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(3);
                                  }}
                                >
                                  Ya
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </th>
              </tr>
              <tr className="w-full">
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <div className="flex shadow-sm px-3 py-2 rounded-md">
                    <img src={OVO} className="h-12" alt="" />
                  </div>
                </th>
                <th className=" px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  OVO
                </th>
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  9213103813018
                </th>

                <th className="w-4/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Jln. Soekarno Hatta No.6, Malang, Jawa Timur
                </th>
                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <button className="bg-green-100 px-4 py-2 text-sm text-white rounded-md">
                    Aktif
                  </button>
                </th>

                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider ">
                  <div className="flex w-full items-center justify-center">
                    <button
                      className="mx-1"
                      onClick={() => {
                        toggleDelete(4);
                      }}
                    >
                      <img
                        src="/assets/icon/trash-can.svg"
                        className="h-5"
                        alt=""
                      />
                    </button>
                    <hr className="mx-1 border-r border-gray-300 h-5" />
                    <button className="mx-1">
                    <Link to="/account/edit-account">
                        <img
                          src="/assets/icon/bxs-pencil.svg"
                          className="h-5"
                          alt=""
                        />
                      </Link>
                    </button>
                    {toggleDeleteBtnIndex === 4 && (
                      <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                        <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                          <div
                            className="py-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="options-menu"
                          >
                            <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                              <p className="text-sm font-semibold">
                                Yakin Ingin menghapus item ini ?
                              </p>
                              <div className="flex ml-auto mt-6">
                                <button
                                  className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(4);
                                  }}
                                >
                                  Tidak
                                </button>
                                <button
                                  className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(4);
                                  }}
                                >
                                  Ya
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </th>
              </tr>
              <tr className="w-full">
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <div className="flex shadow-sm px-3 py-2 rounded-md">
                    <img src={Dana} className="h-12 mr-auto ml-auto" alt="" />
                  </div>
                </th>
                <th className=" px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Dana
                </th>
                <th className="w-2/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  9213103813018
                </th>

                <th className="w-4/12  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  Jln. Soekarno Hatta No.6, Malang, Jawa Timur
                </th>
                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider">
                  <button className="bg-green-100 px-4 py-2 text-sm text-white rounded-md">
                    Aktif
                  </button>
                </th>

                <th className="  px-6 py-4 border-b-2 border-seashell-500 text-left leading-4 text-gray-600 tracking-wider ">
                  <div className="flex w-full items-center justify-center">
                    <button
                      className="mx-1"
                      onClick={() => {
                        toggleDelete(5);
                      }}
                    >
                      <img
                        src="/assets/icon/trash-can.svg"
                        className="h-5"
                        alt=""
                      />
                    </button>
                    <hr className="mx-1 border-r border-gray-300 h-5" />
                    <button className="mx-1">
                    <Link to="/account/edit-account">
                        <img
                          src="/assets/icon/bxs-pencil.svg"
                          className="h-5"
                          alt=""
                        />
                      </Link>
                    </button>
                    {toggleDeleteBtnIndex === 5 && (
                      <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                        <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                          <div
                            className="py-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="options-menu"
                          >
                            <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                              <p className="text-sm font-semibold">
                                Yakin Ingin menghapus item ini ?
                              </p>
                              <div className="flex ml-auto mt-6">
                                <button
                                  className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(5);
                                  }}
                                >
                                  Tidak
                                </button>
                                <button
                                  className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(5);
                                  }}
                                >
                                  Ya
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </th>
              </tr>
            </tbody>
          </table>
          <div className="sm:flex-1 sm:flex sm:items-center sm:justify-between mt-4 work-sans float-right">
            <div>
              <nav className="relative z-0 inline-flex shadow-sm">
                <div>
                  <a
                    href="/"
                    className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-seashell-500 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                    aria-label="Previous"
                  >
                    Sebelumnya
                  </a>
                </div>
                <div>
                  <a
                    href="/"
                    className="-ml-px relative inline-flex items-center px-4 py-2 border border-seashell-500 bg-white text-sm leading-5 font-medium text-green-700 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                  >
                    1
                  </a>
                  <a
                    href="/"
                    className="-ml-px relative inline-flex items-center px-4 py-2 border border-seashell-500 bg-white text-sm leading-5 font-medium text-green-600 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                  >
                    2
                  </a>
                  <a
                    href="/"
                    className="-ml-px relative inline-flex items-center px-4 py-2 border border-seashell-500 bg-white text-sm leading-5 font-medium text-green-600 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                  >
                    3
                  </a>
                </div>
                <div>
                  <a
                    href="/"
                    className="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-seashell-500 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                    aria-label="Next"
                  >
                    Selanjutnya
                  </a>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListAccount;
